import { Component, OnInit, Output, EventEmitter, Input, OnChanges, OnDestroy } from '@angular/core';
import { DispatchBoardPanels } from "../../shared/enums/DispatchBoardPanels";
import { DispatchBoardService } from '../../shared/services/dispatch-board.service';
import { DispatchBoardSearch } from '../../shared/models/DispatchBoardSearch';
import { GlobalsService } from '../../shared/services/globals.service';
import { DispatchDropLocation } from '../../shared/models/DispatchDropLocation';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { Subscription } from 'rxjs';
import { DQOIReferenceData } from '../../shared/models/DQOIReferenceData';
import { AppSettings } from '../../shared/models/AppSettings';
import { CommonValues } from '@app/cp/shared/static/CommonValues';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { CmProAuthService } from '@app/core/services';
import { UsersBus } from '@app/cp/shared/models/UsersBus.model';

@Component({
    selector: 'cp-status-calendar-panel',
    templateUrl: './status-panel-calendar.component.html',
    styleUrls: ['./status-panel-calendar.component.scss'],
    standalone: false
})
export class StatusPanelCalendarComponent implements OnInit, OnDestroy, OnChanges {

    subscriptions: Subscription[] = [];

    constructor(private svc_globals: GlobalsService, private svc_data: DispatchBoardService, private qry_rd: DQOIReferenceDataQuery, private authService: CmProAuthService) {
        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.svc_globals.companyId).subscribe();

        this.subscriptions.push(svc_data.refreshTrigger$.subscribe(
            refresh => {
                //if (!svc_data.getStatusToRefresh()) {this.initData();
                //}
                this.initData();
            }));
    }
    subs_dataRef: Subscription;
    sch: DispatchBoardSearch = new DispatchBoardSearch(null);
    data: any;
    boardStatusesData: any;
    searchParam: DispatchBoardSearch;
    filterSettings: DropDownFilterSettings;
    customerFilter: string = '';
    panelType: DispatchBoardPanels = DispatchBoardPanels.status;
    chkOTOntop: Boolean = true;
    @Input() selectedView: string;
    @Input() viewName: any;
    @Output() openDetailRequest = new EventEmitter<object>();
    @Output() openDispatchRequest = new EventEmitter<object>();
    popupLock: boolean = false;
    loadingIndicator: boolean = true;
    quickFilter: string;
    quickFilterError: boolean = false;
    userSetttings: AppSettings = new AppSettings();
    columnWidth: Number = 250;

    mouseDown: boolean = false;

    ngOnChanges() {
        this.initData();
    }

    ngOnInit() {
        this.searchParam = this.sch;
        this.searchParam.userId = this.svc_globals.userId;
        this.filterSettings = this.svc_data.filterSettings;

        this.authService.subscribeToLoginEvents((user: UsersBus) => {
            if (user) {
                var settings = JSON.parse(localStorage.getItem(CommonValues.StorageKeys_UserSettings));
                this.userSetttings.setSettingsLoad(settings);
                this.columnWidth = this.userSetttings.DispatchBoardStatusWidth;
            }
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
        CommonFunctions.unsubscribe(this.subs_dataRef);
        this.authService.unsubscribeToLoginEvents();
    }

    initData() {
        if (this.selectedView) {
            this.svc_data.GetDispatchBoardViewStatuses(this.selectedView).subscribe(data => {
                this.boardStatusesData = data;
                this.svc_data.boardStatusesData = this.boardStatusesData;

                if (data.error) {
                    // alert('got an error back!');
                }
                this.searchParam.boardStatuses = [];
                for (var i = 0; i < this.boardStatusesData.length; i++) {
                    this.searchParam.boardStatuses.push(this.boardStatusesData[i].dispatchStatusId);
                }
            });
            // MM: move this call outside above results call as dont need the statuses to get the info now
            //if (this.searchParam.customSearch) {
            this.svc_data.GetOpenDispatches(this.searchParam).subscribe(data => {
                this.data = data;
                this.svc_data.statusList = data;
                this.loadingIndicator = false;
                if (data.error) {
                    //   alert('got an error back!');
                }
            });
        }
    }

    openDetail(details) {
        this.openDetailRequest.emit({ lock: !this.popupLock, detail: details });
    }

    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }

    setPopupLock(e) {
        this.popupLock = e;
    }
    openDispatchRequestCall(e) {
        this.openDispatchRequest.emit(e);
    }

    filterChange(e) {
        //is value in list?
        if (this.data.find(obj => obj.description == e)) {
            this.quickFilterError = false;
        } else {
            this.quickFilterError = true;
        }
        this.quickFilter = e;
    }
    setCustomerFilter(e) {
        if (e && e.value) {
            this.customerFilter = e.value;
        } else {
            this.customerFilter = '';
        }

    }

    mouseUp(status: DispatchDropLocation) {
        this.svc_data.dispatchDropped(status);
        this.mouseDown = false;
    }

    mouseOver(status: DispatchDropLocation) {
        this.svc_data.mouseHovering(status);
    }

    drop(a: any) {

    }

    setStatusColumnWidth(value) {
    }
}
